export default __webpack_public_path__ + "static/ringType2-6c1c40c673f3bc5cc8b9730b80a572c8.png";